'use strict';
define(['chart.js'], function (Chart) {
    function suiteThemeToken(name, fallback) {
        var value = window.getComputedStyle(document.documentElement).getPropertyValue(name);
        return value && value.trim() ? value.trim() : fallback;
    }

    var organicGradientPlugin = {
        beforeDraw: function (chart) {
            if (!chart.options || !chart.options.trafficOrganicGradient) return;
            var area = chart.chartArea;
            if (!area || !chart.ctx) return;
            var gradient = chart.ctx.createLinearGradient(0, area.top, 0, area.bottom);
            var darkMode = document.documentElement.getAttribute('data-theme') === 'dark';
            if (darkMode) {
                gradient.addColorStop(0, 'rgba(168, 85, 247, .22)');
                gradient.addColorStop(.3, 'rgba(192, 132, 252, .13)');
                gradient.addColorStop(.58, 'rgba(168, 85, 247, .06)');
                gradient.addColorStop(.8, 'rgba(216, 180, 254, .02)');
                gradient.addColorStop(1, 'rgba(21, 21, 24, 0)');
            } else {
                gradient.addColorStop(0, 'rgba(168, 85, 247, .25)');
                gradient.addColorStop(.16, 'rgba(192, 132, 252, .18)');
                gradient.addColorStop(.38, 'rgba(168, 85, 247, .11)');
                gradient.addColorStop(.62, 'rgba(196, 148, 255, .06)');
                gradient.addColorStop(.82, 'rgba(216, 180, 254, .025)');
                gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
            }
            (chart.data.datasets || []).forEach(function (dataset, index) {
                if (dataset.stoSeriesId !== 'organic') return;
                dataset.backgroundColor = gradient;
                var meta = chart.getDatasetMeta(index);
                if (meta && meta.dataset && meta.dataset._model) {
                    meta.dataset._model.backgroundColor = gradient;
                }
            });
        }
    };
    if (!Chart.__stoOrganicGradientPluginRegistered) {
        Chart.pluginService.register(organicGradientPlugin);
        Chart.__stoOrganicGradientPluginRegistered = true;
    }

    function SEOCheckerTrafficController($scope, $timeout, TrafficInsightsService, $translate) {
        var vm = $scope;
        var ctrl = this;
        var countryRequestId = 0;
        var countryCache = {};
        var trendChart = null;
        var chartRequestId = 0;
        var channelsChart = null;
        var channelsChartRequestId = 0;
        var TRAFFIC_DATA_YEARS = 5;

        vm.trafficLoading = true;
        vm.trafficError = false;
        vm.trafficCountryLoading = false;
        vm.trafficCountryError = false;
        vm.selectedCountryCode = null;
        vm.countryMenuOpen = false;
        vm.trafficRangeId = '1y';
        vm.trafficRangeOptions = [
            {id: '1m', labelKey: 'workspace.trafficRange1m', shortKey: 'workspace.trafficRange1mShort', months: 1},
            {id: '3m', labelKey: 'workspace.trafficRange3m', shortKey: 'workspace.trafficRange3mShort', months: 3},
            {
                id: 'previous-quarter',
                labelKey: 'workspace.trafficRangeQuarter',
                shortKey: 'workspace.trafficRangeQuarterShort',
                quarter: true,
            },
            {id: '1y', labelKey: 'workspace.trafficRange1y', shortKey: 'workspace.trafficRange1yShort', months: 12},
            {id: '3y', labelKey: 'workspace.trafficRange3y', shortKey: 'workspace.trafficRange3yShort', months: 36},
            {id: '5y', labelKey: 'workspace.trafficRange5y', shortKey: 'workspace.trafficRange5yShort', months: 60},
        ];
        vm.trafficRangeOptions.forEach(function (option) {
            option.shortLabel = $translate.instant(option.shortKey);
        });
        vm.trafficRangeToggleOptions = vm.trafficRangeOptions.map(function (option) {
            return {value: option.id, label: option.shortKey};
        });
        vm.visibleTrendTypes = {
            organic: true,
            paid: false,
            featured_snippet: false,
            local_pack: false,
        };
        vm.trendMenuOpen = false;

        vm.formatTraffic = formatTraffic;
        vm.formatTrafficValue = formatTrafficValue;
        vm.countryFlag = countryFlag;
        vm.countryScopeLabel = countryScopeLabel;
        vm.trafficRangeLabel = trafficRangeLabel;
        vm.trafficDataNotice = trafficDataNotice;
        vm.visibleTrendSeries = visibleTrendSeries;
        vm.isTrendSeriesVisible = isTrendSeriesVisible;
        vm.trendSelectionLabel = trendSelectionLabel;
        vm.channelShare = channelShare;
        vm.selectedCountryLabel = selectedCountryLabel;
        vm.selectedCountryName = selectedCountryName;
        vm.toggleCountryMenu = function () {
            if (!vm.trafficCountryLoading) vm.countryMenuOpen = !vm.countryMenuOpen;
        };
        vm.chooseCountry = function (locationCode) {
            vm.countryMenuOpen = false;
            selectCountry(locationCode);
        };
        vm.changeTrafficRange = function (rangeId) {
            if (!rangeId || rangeId === vm.trafficRangeId || vm.trafficCountryLoading) return;
            vm.trafficRangeId = rangeId;
            if (vm.trafficSourceData) applyTraffic(vm.trafficSourceData);
        };
        vm.toggleTrendSeries = function (series) {
            if (!series || !Object.prototype.hasOwnProperty.call(vm.visibleTrendTypes, series.id)) return;
            var activeCount = Object.keys(vm.visibleTrendTypes).filter(function (id) {
                return vm.visibleTrendTypes[id];
            }).length;
            if (vm.visibleTrendTypes[series.id] && activeCount === 1) return;
            vm.visibleTrendTypes[series.id] = !vm.visibleTrendTypes[series.id];
            renderTrendChart();
        };
        vm.toggleTrendMenu = function () {
            vm.trendMenuOpen = !vm.trendMenuOpen;
        };
        vm.retryTraffic = function () {
            loadTraffic();
        };

        ctrl.$onInit = function () {
            $scope.$root.projectSectionLoading = false;
            loadTraffic();
        };

        $scope.$on('$destroy', function () {
            chartRequestId += 1;
            channelsChartRequestId += 1;
            if (trendChart) {
                trendChart.destroy();
                trendChart = null;
            }
            if (channelsChart) {
                channelsChart.destroy();
                channelsChart = null;
            }
        });

        ctrl.$onChanges = function (changes) {
            if (changes.projectId && !changes.projectId.isFirstChange() && ctrl.projectId) {
                countryCache = {};
                vm.selectedCountryCode = null;
                loadTraffic();
            }
        };

        function loadTraffic() {
            if (!ctrl.projectId) {
                vm.trafficError = true;
                vm.trafficLoading = false;
                return;
            }
            vm.trafficLoading = true;
            vm.trafficError = false;
            return TrafficInsightsService.getProject(ctrl.projectId, null, TRAFFIC_DATA_YEARS)
                .then(function (data) {
                    if (!data) {
                        vm.trafficError = true;
                        return;
                    }
                    vm.worldwideTraffic = data;
                    vm.selectedCountryCode = null;
                    applyTraffic(data);
                })
                .catch(function () {
                    vm.trafficError = true;
                })
                .finally(function () {
                    vm.trafficLoading = false;
                });
        }

        function selectCountry(value) {
            vm.selectedCountryCode = value || null;
            if (!value) {
                countryRequestId += 1;
                vm.trafficCountryLoading = false;
                vm.trafficCountryError = false;
                if (vm.worldwideTraffic) applyTraffic(vm.worldwideTraffic);
                return;
            }
            var locationCode = Number(value);
            var cacheKey = String(locationCode);
            var previousCode = vm.traffic && vm.traffic.selectedCountry
                && vm.traffic.selectedCountry.code !== 'WORLD'
                ? vm.traffic.selectedCountry.locationCode
                : null;
            if (countryCache[cacheKey]) {
                applyTraffic(countryCache[cacheKey]);
                return;
            }
            var requestId = ++countryRequestId;
            vm.trafficCountryLoading = true;
            vm.trafficCountryError = false;
            TrafficInsightsService.getProject(
                ctrl.projectId,
                locationCode,
                TRAFFIC_DATA_YEARS,
            )
                .then(function (data) {
                    if (requestId !== countryRequestId) return;
                    countryCache[cacheKey] = data;
                    applyTraffic(data);
                })
                .catch(function () {
                    if (requestId !== countryRequestId) return;
                    vm.selectedCountryCode = previousCode;
                    vm.trafficCountryError = true;
                })
                .finally(function () {
                    if (requestId === countryRequestId) vm.trafficCountryLoading = false;
                });
        }

        function applyTraffic(data) {
            vm.trafficSourceData = data;
            vm.traffic = Object.assign({}, data, {
                trend: filterTrendByRange(data.trend),
                paidTrend: filterTrendByRange(data.paidTrend),
                featuredSnippetTrend: filterTrendByRange(data.featuredSnippetTrend),
                localPackTrend: filterTrendByRange(data.localPackTrend),
                countries: (data.countries || []).map(function (country) {
                    return Object.assign({}, country, {displayName: localizedCountryName(country)});
                }),
                selectedCountry: data.selectedCountry
                    ? Object.assign({}, data.selectedCountry, {displayName: localizedCountryName(data.selectedCountry)})
                    : data.selectedCountry,
            });
            vm.trafficChartData = buildChartData(vm.traffic.trend || []);
            vm.trendSeries = [
                trendSeries('organic', 'workspace.trafficSeriesOrganic', vm.traffic.trend),
                trendSeries('paid', 'workspace.trafficSeriesPaid', vm.traffic.paidTrend),
                trendSeries(
                    'featured_snippet',
                    'workspace.trafficSeriesFeaturedSnippet',
                    vm.traffic.featuredSnippetTrend,
                ),
                trendSeries('local_pack', 'workspace.trafficSeriesLocalPack', vm.traffic.localPackTrend),
            ];
            var channelKeys = {
                organic: 'workspace.trafficSeriesOrganic',
                paid: 'workspace.trafficSeriesPaid',
                featured_snippet: 'workspace.trafficSeriesFeaturedSnippet',
                local_pack: 'workspace.trafficSeriesLocalPack'
            };
            vm.traffic.channelBreakdown = (vm.traffic.channelBreakdown || []).map(function (channel) {
                return Object.assign({}, channel, {
                    tkey: channelKeys[channel.id],
                    label: channelKeys[channel.id] ? $translate.instant(channelKeys[channel.id]) : channel.label
                });
            });
            renderTrendChart();
            renderChannelsChart();
            vm.trafficUpdatedAt = data.source && data.source.fetchedAt
                ? new Date(data.source.fetchedAt).toLocaleDateString($translate.use() || 'en-US', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric',
                })
                : '';
        }

        function countryScopeLabel() {
            var country = vm.traffic && vm.traffic.selectedCountry;
            if (!country || country.code === 'WORLD') return $translate.instant('workspace.trafficScopeWorldwide');
            return $translate.instant('workspace.trafficScopeCountry', {country: country.displayName || country.name});
        }

        function trafficRangeLabel() {
            var option = selectedTrafficRange();
            return option ? $translate.instant(option.labelKey) : $translate.instant('workspace.trafficRange1y');
        }

        function trafficDataNotice() {
            var latestPeriod = vm.traffic && vm.traffic.latestPeriod;
            if (!latestPeriod) return '';
            var now = new Date();
            var expected = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 1, 1));
            var expectedPeriod = expected.toISOString().slice(0, 7);
            if (latestPeriod >= expectedPeriod) return '';
            var parts = latestPeriod.split('-');
            var date = new Date(Date.UTC(Number(parts[0]), Number(parts[1]) - 1, 1));
            var label = date.toLocaleDateString($translate.use() || 'en-US', {
                month: 'long',
                year: 'numeric',
                timeZone: 'UTC',
            });
            return $translate.instant('workspace.trafficDataNotice', {date: label});
        }

        function selectedTrafficRange() {
            return vm.trafficRangeOptions.filter(function (option) {
                return option.id === vm.trafficRangeId;
            })[0] || null;
        }

        function filterTrendByRange(trend) {
            var values = trend || [];
            var option = selectedTrafficRange();
            if (!option) return values.slice(-12);
            if (!option.quarter) return values.slice(-option.months);

            var now = new Date();
            var currentQuarterStart = Math.floor(now.getUTCMonth() / 3) * 3;
            var start = new Date(Date.UTC(
                now.getUTCFullYear(),
                currentQuarterStart - 3,
                1,
            ));
            var end = new Date(Date.UTC(
                now.getUTCFullYear(),
                currentQuarterStart,
                0,
            ));
            var startKey = start.toISOString().slice(0, 7);
            var endKey = end.toISOString().slice(0, 7);
            return values.filter(function (item) {
                return item.key >= startKey && item.key <= endKey;
            });
        }

        function trendSeries(id, tkey, trend) {
            return {
                id: id,
                tkey: tkey,
                label: $translate.instant(tkey),
                values: (trend || []).map(function (item) {
                    return Number(item.traffic) || 0;
                }),
                change: trendChange(trend),
            };
        }

        function isTrendSeriesVisible(series) {
            return !!series && vm.visibleTrendTypes[series.id] === true;
        }

        function trendSelectionLabel() {
            var selected = (vm.trendSeries || []).filter(isTrendSeriesVisible);
            if (selected.length === 1) return selected[0].label;
            return $translate.instant('workspace.trafficSeriesCount', {count: selected.length});
        }

        function visibleTrendSeries() {
            return (vm.trendSeries || []).filter(function (series) {
                return isTrendSeriesVisible(series);
            });
        }

        function renderChannelsChart() {
            var requestId = ++channelsChartRequestId;
            $timeout(function () {
                var canvas = document.getElementById('stTrafficChannelsChart');
                if (!canvas || requestId !== channelsChartRequestId || !vm.traffic) return;
                var channels = vm.traffic.channelBreakdown || [];
                var labels = channels.map(function (channel) {
                    return channel.label;
                });
                var values = channels.map(function (channel) {
                    return Number(channel.traffic) || 0;
                });
                var colors = {
                    organic: '#a855f7',
                    paid: '#2563eb',
                    featured_snippet: '#e8c84f',
                    local_pack: '#2ed47a',
                };
                var chartSurface = suiteThemeToken('--sto-color-surface', '#fff');
                var chartText = suiteThemeToken('--sto-color-text', '#18181b');
                var chartTooltip = suiteThemeToken('--sto-color-surface-hover', '#18181b');
                if (channelsChart) channelsChart.destroy();
                channelsChart = new Chart(canvas.getContext('2d'), {
                    type: 'pie',
                    data: {
                        labels: labels,
                        datasets: [{
                            data: values,
                            backgroundColor: channels.map(function (channel) {
                                return colors[channel.id] || '#a1a1aa';
                            }),
                            borderColor: chartSurface,
                            borderWidth: 2,
                        }],
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        animation: {duration: 420},
                        legend: {display: false},
                        tooltips: {
                            displayColors: false,
                            backgroundColor: chartTooltip,
                            titleFontColor: chartText,
                            bodyFontColor: chartText,
                            callbacks: {
                                label: function (item) {
                                    var channel = channels[item.index];
                                    return $translate.instant('workspace.trafficChannelTooltip', {
                                        label: channel.label || '',
                                        value: formatTraffic(channel.traffic),
                                        share: localizedNumber(channelShare(channel), 1)
                                    });
                                },
                            },
                        },
                    },
                });
            }, 0);
        }

        function selectedCountryLabel() {
            if (!vm.selectedCountryCode || !vm.traffic || !vm.traffic.countries) {
                return $translate.instant('workspace.trafficWorldwideAllCountries');
            }
            var country = vm.traffic.countries.filter(function (item) {
                return Number(item.locationCode) === Number(vm.selectedCountryCode);
            })[0];
            return country
                ? (country.displayName || country.name) + ' · ' + localizedNumber(Number(country.share || 0), 1) + '%'
                : $translate.instant('workspace.trafficWorldwideAllCountries');
        }

        function selectedCountryName() {
            var country = vm.traffic && vm.traffic.selectedCountry;
            return country ? (country.displayName || country.name) : '';
        }

        function localizedCountryName(country) {
            var code = String(country && country.code || '').toUpperCase();
            if (code !== 'WORLD' && code.length === 2 && typeof Intl !== 'undefined' && Intl.DisplayNames) {
                try {
                    return new Intl.DisplayNames([$translate.use() || 'en-US'], {type: 'region'}).of(code)
                        || country.name || code;
                } catch (error) {}
            }
            return country && country.name || code;
        }

        function channelShare(channel) {
            var channels = vm.traffic && vm.traffic.channelBreakdown || [];
            var total = channels.reduce(function (sum, item) {
                return sum + (Number(item.traffic) || 0);
            }, 0);
            return total ? ((Number(channel.traffic) || 0) / total) * 100 : 0;
        }

        function formatTraffic(value) {
            var amount = Number(value) || 0;
            if (Math.abs(amount) >= 1000000000) {
                return localizedNumber(amount / 1000000000, 1) + 'B';
            }
            if (Math.abs(amount) >= 1000000) {
                return localizedNumber(amount / 1000000, 1) + 'M';
            }
            if (Math.abs(amount) >= 1000) {
                return localizedNumber(amount / 1000, 1) + 'K';
            }
            return Math.round(amount).toLocaleString($translate.use() || 'en-US');
        }

        function localizedNumber(value, digits) {
            return Number(value || 0).toLocaleString($translate.use() || 'en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: digits
            });
        }

        function formatTrafficValue(value) {
            return '$' + formatTraffic(value);
        }

        function countryFlag(code) {
            var normalized = String(code || '').toUpperCase();
            if (normalized.length !== 2) {
                return '🌐';
            }
            return String.fromCodePoint(
                normalized.charCodeAt(0) + 127397,
                normalized.charCodeAt(1) + 127397
            );
        }

        function trendChange(trend) {
            if (!trend || trend.length < 2) {
                return null;
            }
            var first = Number(trend[0].traffic);
            var last = Number(trend[trend.length - 1].traffic);
            if (!first) return last ? 100 : 0;
            return ((last - first) / first) * 100;
        }

        function buildChartData(trend) {
            var option = selectedTrafficRange();
            var includeYear = !!(option && option.months > 12);
            return {
                labels: trend.map(function (item) {
                    return monthLabel(item, includeYear);
                }),
                fullLabels: trend.map(function (item) {
                    return fullMonthYearLabel(item);
                }),
                values: trend.map(function (item) {
                    return Number(item.traffic) || 0;
                }),
            };
        }

        function renderTrendChart() {
            var requestId = ++chartRequestId;
            $timeout(function () {
                var canvas = document.getElementById('stTrafficTrendChart');
                if (!canvas || requestId !== chartRequestId || !vm.trafficChartData) return;
                var context = canvas.getContext('2d');
                var pointRadius = vm.trafficChartData.values.length > 36 ? 2 : 4;
                var maxTicks = vm.trafficChartData.values.length > 36
                    ? 12
                    : (vm.trafficChartData.values.length > 12 ? 8 : 7);
                var colors = {
                    organic: '#a855f7',
                    paid: '#2563eb',
                    featured_snippet: '#e8c84f',
                    local_pack: '#2ed47a',
                };
                var backgrounds = {
                    organic: suiteThemeToken('--sto-color-surface', '#fff'),
                    paid: 'rgba(37, 99, 235, .06)',
                    featured_snippet: 'rgba(232, 200, 79, .08)',
                    local_pack: 'rgba(46, 212, 122, .07)',
                };
                var chartSurface = suiteThemeToken('--sto-color-surface', '#fff');
                var chartText = suiteThemeToken('--sto-color-text', '#18181b');
                var chartMuted = suiteThemeToken('--sto-color-text-subtle', '#a1a1aa');
                var chartTooltip = suiteThemeToken('--sto-color-surface-hover', '#18181b');
                var dashStyles = {
                    organic: [],
                    paid: [5, 4],
                    featured_snippet: [2, 3],
                    local_pack: [7, 3, 2, 3],
                };
                var chartSeries = visibleTrendSeries();
                if (trendChart) trendChart.destroy();
                trendChart = new Chart(context, {
                    type: 'line',
                    data: {
                        labels: vm.trafficChartData.labels,
                        datasets: chartSeries.map(function (series) {
                            return {
                                stoSeriesId: series.id,
                                label: series.label,
                                data: series.values,
                                borderColor: colors[series.id],
                                backgroundColor: backgrounds[series.id],
                                borderWidth: 2.5,
                                borderDash: dashStyles[series.id],
                                fill: series.id === 'organic',
                                lineTension: .35,
                                pointRadius: pointRadius,
                                pointHoverRadius: 5,
                                pointBorderWidth: 2,
                                pointBorderColor: colors[series.id],
                                pointBackgroundColor: chartSurface,
                                pointHoverBorderColor: colors[series.id],
                                pointHoverBackgroundColor: chartSurface,
                            };
                        }),
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        trafficOrganicGradient: true,
                        animation: {
                            duration: 520,
                            easing: 'easeOutQuart',
                        },
                        layout: {
                            padding: {top: 8, right: 8, bottom: 0, left: 8},
                        },
                        legend: {display: false},
                        hover: {mode: 'index', intersect: false},
                        tooltips: {
                            mode: 'index',
                            intersect: false,
                            displayColors: false,
                            backgroundColor: chartTooltip,
                            titleFontColor: chartText,
                            bodyFontColor: chartText,
                            xPadding: 10,
                            yPadding: 8,
                            callbacks: {
                                title: function (items) {
                                    if (!items.length) return '';
                                    return vm.trafficChartData.fullLabels[items[0].index]
                                        || items[0].xLabel;
                                },
                                label: function (item) {
                                    var series = chartSeries[item.datasetIndex];
                                    var label = series ? series.label : $translate.instant('workspace.trafficFallbackSeries');
                                    return $translate.instant('workspace.trafficTooltip', {
                                        label: label,
                                        value: formatTraffic(item.yLabel)
                                    });
                                },
                            },
                        },
                        scales: {
                            xAxes: [{
                                gridLines: {display: false, drawBorder: false},
                                ticks: {
                                    maxTicksLimit: maxTicks,
                                    fontColor: chartMuted,
                                    fontSize: 10,
                                    padding: 8,
                                },
                            }],
                            yAxes: [{
                                display: false,
                                ticks: {beginAtZero: false},
                                gridLines: {display: false, drawBorder: false},
                            }],
                        },
                    },
                });
            }, 0);
        }

        function monthLabel(item, includeYear) {
            var date = new Date(Date.UTC(item.year, item.month - 1, 1));
            var label = date.toLocaleDateString($translate.use() || 'en-US', {
                month: 'short',
                year: includeYear ? 'numeric' : undefined,
                timeZone: 'UTC',
            }).replace('.', '');
            return label.charAt(0).toUpperCase() + label.slice(1);
        }

        function fullMonthYearLabel(item) {
            var date = new Date(Date.UTC(item.year, item.month - 1, 1));
            var label = date.toLocaleDateString($translate.use() || 'en-US', {
                month: 'long',
                year: 'numeric',
                timeZone: 'UTC',
            });
            return label.charAt(0).toUpperCase() + label.slice(1);
        }

    }

    SEOCheckerTrafficController.$inject = ['$scope', '$timeout', 'TrafficInsightsService', '$translate'];
    return SEOCheckerTrafficController;
});
